export function convertFilePathToUrl(filePath?: string | null) {
  if (!filePath) {
    return "";
  }

  if (typeof filePath !== "string") {
    return "";
  }

  if (filePath.startsWith("blob:")) {
    return filePath;
  }

  if (filePath.startsWith("https://") || filePath.startsWith("http://")) {
    return filePath.replace("-internal", "");
  }

  if (
    !filePath.startsWith("/work/aion-runtime-dev") &&
    !filePath.startsWith("/work/aion-runtime-staging") &&
    !filePath.startsWith("/work/aion-runtime-prod")
  ) {
    return "";
  }

  return filePath
    .replace(`/work/aion-runtime-dev`, "https://vidmuse-dev.sandcdn.com/static")
    .replace(
      `/work/aion-runtime-staging`,
      "https://vidmuse-staging.sandcdn.com/static"
    )
    .replace(`/work/aion-runtime-prod`, "https://vidmuse.sandcdn.com/static");
}
